module.exports = __webpack_public_path__ + "img/plus-white.9dbff9af.svg";